import { IAssetAllocationItem, IProductAllocationItem } from 'api/common.types'
import { uniq, sum } from 'lodash'
import { isNotNullOrEmpty } from 'shared/gaurds'
import {
  IExportConfiguration,
  IExportDefinition
} from '../core/contracts/IExportDefinition'
import { CommonColumnIdsEnum } from './CommonColumnIdsEnum'

export interface IWithProductOrAssetAllocation {
  productAllocation?: IProductAllocationItem[]
  assetAllocationLvl1?: IAssetAllocationItem[]
}

export const BaseExportConfigurations: Record<
  string,
  IExportConfiguration<IWithProductOrAssetAllocation>
> = {
  [CommonColumnIdsEnum.productAllocation]: {
    columnId: CommonColumnIdsEnum.productAllocation,
    getExportColumns: (data) => {
      const types = uniq(
        data.flatMap((x) => x.productAllocation?.map((x) => x.productType))
      ).filter(isNotNullOrEmpty)

      return types.map(
        (type): IExportDefinition<IWithProductOrAssetAllocation> => ({
          columnId: `product_${type}`,
          columnName: `Product Allocation - ${type}`,
          getValue: (item) => {
            return sum(
              item.productAllocation
                ?.filter((x) => x.productType === type)
                .map((x) => x.value || 0)
            )
          }
        })
      )
    }
  },
  [CommonColumnIdsEnum.assetAllocation]: {
    columnId: CommonColumnIdsEnum.assetAllocation,
    getExportColumns: (data) => {
      const types = uniq(
        data.flatMap((x) => x.assetAllocationLvl1?.map((x) => x.assetType))
      ).filter(isNotNullOrEmpty)

      return types.map(
        (type): IExportDefinition<IWithProductOrAssetAllocation> => ({
          columnId: `asset_${type}`,
          columnName: `Asset Allocation - ${type}`,
          getValue: (item) => {
            return sum(
              item.assetAllocationLvl1
                ?.filter((x) => x.assetType === type)
                .map((x) => x.value || 0)
            )
          }
        })
      )
    }
  }
}
